import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import * as _ from 'lodash';
var HttpClientService = (function () {
    function HttpClientService(http, router) {
        this.http = http;
        this.router = router;
    }
    HttpClientService.prototype.checkError = function (apiFunction) {
        var _this = this;
        return new Observable(function (observer) {
            apiFunction.subscribe(function (res) {
                observer.next(res);
                observer.complete();
            }, function (err) {
                if (_.get(err, 'error.detail') === 'Signature has expired.' ||
                    _.get(err, 'error.detail') === 'Error decoding signature.' ||
                    _.get(err, 'error.detail') === 'Invalid signature.' ||
                    _.get(err, 'error.detail') === 'User account is disabled.' ||
                    _.get(err, 'error.detail') === 'บัญชีผู้ใช้ถูกระงับ') {
                    localStorage.clear();
                    _this.router.navigate(['login', 'ล็อกอินหมดอายุ โปรดล็อกอินอีกครั้ง'], { skipLocationChange: true });
                }
                observer.error(err);
            });
        });
    };
    HttpClientService.prototype.getHeader = function () {
        return new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('currentUser')).set('Accept-Language', 'th,en');
    };
    HttpClientService.prototype.get = function (url, params) {
        return this.checkError(this.http.get(url, { params: params, headers: this.getHeader() }));
    };
    HttpClientService.prototype.getBlob = function (url, params) {
        return this.checkError(this.http.get(url, { params: params, headers: this.getHeader(), responseType: 'blob' }));
    };
    HttpClientService.prototype.post = function (url, data) {
        return this.checkError(this.http.post(url, data, { headers: this.getHeader() }));
    };
    HttpClientService.prototype.postBlob = function (url, data) {
        return this.checkError(this.http.post(url, data, { headers: this.getHeader(), responseType: 'blob' }));
    };
    HttpClientService.prototype.put = function (url, data, params) {
        return this.checkError(this.http.put(url, data, { params: params, headers: this.getHeader() }));
    };
    HttpClientService.prototype.patch = function (url, data) {
        return this.checkError(this.http.patch(url, data, { headers: this.getHeader() }));
    };
    HttpClientService.prototype.delete = function (url) {
        return this.checkError(this.http.delete(url, { headers: this.getHeader() }));
    };
    return HttpClientService;
}());
export { HttpClientService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/http-client.service.ts.pre-build-optimizer.js